import React from "react";

const AnnounceScreen = () => {
  return <div>AnnounceScreen</div>;
};

export default AnnounceScreen;
